/**
 * Utilitário de formatação de datas para evitar bug de timezone.
 *
 * Datas do SQL Server vêm como "2026-02-20T00:00:00.000Z" (UTC).
 * new Date() converte para UTC-3 (Brasil) → dia errado.
 * Essas funções extraem a parte da data diretamente da string ISO.
 */

/**
 * Formata data no padrão dd/mm/aaaa (sem conversão de timezone)
 */
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const str = typeof dateString === 'string' ? dateString : new Date(dateString).toISOString();
  if (str.includes('T')) {
    const [y, m, d] = str.split('T')[0].split('-');
    if (y && m && d) return `${d}/${m}/${y}`;
  }
  // Fallback: tenta parsear como YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const [y, m, d] = str.split('-');
    return `${d}/${m}/${y}`;
  }
  return str;
};

/**
 * Formata data e hora: dd/mm/aaaa HH:mm
 * Se horario vier separado, passar como segundo argumento.
 * Se não, tenta extrair da própria string datetime.
 */
export const formatDateTime = (dateString, horario) => {
  if (!dateString) return '-';
  const datePart = formatDate(dateString);
  if (datePart === '-') return '-';

  // Se horário foi passado separado
  if (horario) {
    const time = formatTime(horario);
    return time !== '-' ? `${datePart} ${time}` : datePart;
  }

  // Tenta extrair hora da string ISO (se não for meia-noite)
  const str = typeof dateString === 'string' ? dateString : new Date(dateString).toISOString();
  if (str.includes('T')) {
    const timePart = str.split('T')[1];
    if (timePart && !timePart.startsWith('00:00:00')) {
      const [h, m] = timePart.split(':');
      return `${datePart} ${h}:${m}`;
    }
  }

  return datePart;
};

/**
 * Formata horário HH:mm a partir de string de tempo ou datetime
 * Aceita: "15:07", "15:07:54", "1970-01-01T15:07:54.000Z", datetime ISO
 */
export const formatTime = (timeString) => {
  if (!timeString) return '-';
  const str = String(timeString);

  // Formato HH:mm ou HH:mm:ss direto
  if (/^\d{2}:\d{2}(:\d{2})?$/.test(str)) {
    return str.substring(0, 5);
  }

  // ISO datetime - extrair hora UTC (HORARIO do SQL Server vem com data fake 1970)
  if (str.includes('T')) {
    const timePart = str.split('T')[1];
    if (timePart) {
      const [h, m] = timePart.split(':');
      if (h && m) return `${h}:${m}`;
    }
  }

  return '-';
};

/**
 * Formata data de nascimento dd/mm/aaaa (mesma lógica, aceita qualquer ano)
 */
export const formatDateOfBirth = (dateString) => {
  return formatDate(dateString);
};
